<template>
    <form-wrapper @form-submit="submit">
        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.user.add_password.fields.password.label')"
                    :placeholder="$t('forms.user.add_password.fields.password.placeholder')"
                    :isRequired="true"
                    type="password"
                    valuePath="password"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.user.add_password.fields.password_repeat.label')"
                    :placeholder="$t('forms.user.add_password.fields.password_repeat.placeholder')"
                    :isRequired="true"
                    type="password"
                    valuePath="passwordRepeat"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    type="primary"
                    :isProcessing="isLoading"
                    :label="$t('forms.user.add_password.buttons.save')"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import UsersAPI from 'api/UsersAPI'

    export default {
        mixins: [FormMixin],

        methods: {
            submit() {
                if (this.data.password !== this.data.passwordRepeat) {
                    this.setErrors([
                        { path: 'password', value: this.$t('forms.user.change_password.passwords_not_match') },
                        { path: 'passwordRepeat', value: this.$t('forms.user.change_password.passwords_not_match') },
                    ])
                    return
                }
                this.submitForm(
                    UsersAPI.addPassword({ password: this.data.password, email: this.data.email }).then(() => {
                        this.$auth.reloadUser()
                    }),
                ).catch(() => {})
            },
        },
    }
</script>
